import { lazyLoad } from '../../../../shared/utils/loadable';

export const PasswordResetEditPage = lazyLoad(
  () => import('./index'),
  (module) => module.PasswordResetEdit,
);
